import { Component, Input } from '@angular/core';
import { CoreMenuItem } from '@core/types';
import { UtilsService } from '../../../../../app/auth/service/utils.service';

@Component({
  selector: '[core-menu-vertical-item]',
  templateUrl: './item.component.html',
})
export class CoreMenuVerticalItemComponent {
  @Input() item: CoreMenuItem;

  @Input() capabilities: Array<string>;

  constructor(private _utilsService: UtilsService) {
  }

  openPopupAbsences(url: string) {
    const type: string = url.split('-').pop();
    this._utilsService.toggleAbsencePopup(type);
  }
}
